import React, { useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import { textStyles } from '../../../../../constants/textStyles';
import { mbTextStyles } from '@mightybyte/rnw.utils.style-utils';
import { trpc } from '../../../../../apiCalls/trpcClient';
import { IdentityCard } from './IdentityCard';
import { TotalCard, ViewType } from './TotalCard';
import { commaSeparatedNumber } from './utils/commaSeparatedNumber';


type Identity = 'lesbian' | 'bisexual' | 'queer';

export function AnalyticsGrid() {
    const { data: stats } = trpc.admin.users.getStats.useQuery();

    let identityStats = useMemo(() => {
        return Object.entries(stats?.identityByAgeStats || {});
    }, [stats]);

    let highestNumber = useMemo(() => {
        let totals = identityStats.flatMap(([_, stat]) =>
            Object.values(stat),
        );
        return Math.max(...totals);
    }, [identityStats]);

    return (
        <View style={styles.container}>
            {stats?.totalUsers && <TotalCard totalUsers={stats?.totalUsers} viewType={ViewType.TOTAL_USERS}/>}
            <View style={styles.identityContainer}>
                {identityStats.map(([identity, ageGroups]) => {
                    return (
                        <IdentityCard
                            identity={identity}
                            ageGroupHash={ageGroups}
                            highestNumber={highestNumber}
                            total={commaSeparatedNumber(
                                stats?.identityStats[identity as Identity] || 0,
                            )}
                        />
                    );
                })}
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },

    exampleText: mbTextStyles([
        textStyles.normalText,
        {
            fontWeight: '400',
            color: '#1E1E1E',
        },
    ]),

    identityContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
});
